module.exports = __webpack_public_path__ + "media/brands/daelim-cae65c96.png";